
/**
 * Service for retrieving test distances for Level 2 tests
 */

/**
 * Get test distances for Level 2 tests
 */
export const getTestDistances = (testId: string): Record<string, string> => {
  console.log("Level2Service.getTestDistances called for:", testId);
  
  // Special case for bunker tests with fixed distances
  if (testId === "bunker-court") {
    return {
      "D": "5m",
      "E": "8m",
      "F": "12m"
    };
  } else if (testId === "bunker-long") {
    return {
      "D1": "15m",
      "E1": "20m"
    };
  }
  
  // Special case for iron tests with fixed distances
  if (testId === "iron-long") {
    return { "D": "130m" };
  } else if (testId === "iron-mid") {
    return { "D": "80m" };
  } else if (testId === "iron-green-attack-100") {
    return { "D": "100m" };
  }
  
  // Special case for fairway wood tests with fixed distances
  if (testId === "fairwayWood-3") {
    return { "D": "180m" };
  } else if (testId === "fairwayWood-5") {
    return { "D": "160m" };
  }
  
  // Special case for driver tests with fixed distances
  if (testId === "driver-practice" || testId === "driver-accuracy") {
    return { "D": "180m" };
  }
  
  // Special case for wedging tests
  if (testId === "wedging-cercles") {
    return { 
      "D": "45m",
      "E": "55m",
      "F": "65m"
    };
  } else if (testId === "wedging-mid") {
    return {
      "D1": "75m",
      "E1": "85m",
      "F1": "95m"
    };
  } else if (testId === "wedging-pente-gauche") {
    return {
      "D2": "45m",
      "E2": "55m",
      "F2": "65m"
    };
  }
  
  // Default distances for other test types
  const distances: Record<string, string> = {};
  
  if (testId.startsWith('putts-')) {
    if (testId === 'putts-plat') {
      distances['D'] = '1,2m';
      distances['E'] = '1,5m';
      distances['F'] = '3m';
    } else if (testId === 'putts-montee') {
      distances['D1'] = '1,2m';
      distances['E1'] = '1,5m';
      distances['F1'] = '3m';
    } else if (testId === 'putts-descente') {
      distances['D2'] = '1,2m';
      distances['E2'] = '1,5m';
      distances['F2'] = '3m';
    } else if (testId === 'putts-pente') {
      distances['D3'] = '1,2m';
      distances['E3'] = '1,5m';
      distances['F3'] = '3m';
    } else if (testId === 'putts-pente-droite') {
      distances['D4'] = '1,2m';
      distances['E4'] = '1,5m';
      distances['F4'] = '3m';
    }
  } else if (testId.startsWith('chipping-')) {
    // Specific distances for chipping tests - LEVEL 2
    if (testId === 'chipping-plat') {
      distances['D'] = '15m';
      distances['E'] = '20m';
      distances['F'] = '25m';
    } else if (testId === 'chipping-pente-droit') {
      distances['D1'] = '15m';
      distances['E1'] = '20m';
      distances['F1'] = '25m';
    } else if (testId === 'chipping-pente-gauche') {
      distances['D2'] = '15m';
      distances['E2'] = '20m';
      distances['F2'] = '25m';
    } else if (testId === 'chipping-roulee-plat') {
      distances['D3'] = '5m';
      distances['E3'] = '10m';
      distances['F3'] = '15m';
    }
  }
  
  console.log("Level2Service.getTestDistances returning:", distances);
  return distances;
};
